import React, { Component } from "react";
import { ListingContext } from "../../Context";
import SkeletonText from "../../components/skeleton/SkeletonText";

import moment from "moment";

export default class ListingRealty extends Component {
  render() {
    return (
      <ListingContext.Consumer>
        {listingContext => {
          const listing = listingContext.listing || {};
          const listingDate = listing.listingDate || {};
          const seconds = listingDate.seconds || "";
          const dateString = moment.unix(seconds).format("MMM Do YYYY");
          if (listingContext.loading) {
            return (
              <div className="listing-realty">
                <SkeletonText lines={2} />
              </div>
            );
          } else if (!!listing.realty && listing.listingDate) {
            return (
              <div className="listing-realty">
                <h5 className="listing-section__title">
                  Posted by{" "}
                  <span className="listing-realty__realty">
                    {listing.realty.toLowerCase()}
                  </span>
                </h5>
                {listing.listingDate && (
                  <p className="listing-realty__date">Posted {dateString}</p>
                )}
              </div>
            );
          } else {
            return null;
          }
        }}
      </ListingContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/listing/ListingRealty.js